import React from 'react'
import { Link } from 'react-router-dom'
import { Routes, Route } from 'react-router'

export const KanbanScreen = () => {
  return (
    <div>
      <h1>KanbanScreen</h1>
    </div>
  )
}
